export default __webpack_public_path__ + "static/media/permanent_eyebrows.17748c07.jpg";